export default "__VITE_ASSET__DSD5hC_x__"